import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { List, ListItem } from "@material-ui/core";
import ClipUtils from "../../utils/ClipUtils.js";

import YouTube from 'react-youtube-embed';
import {Helmet} from "react-helmet";

// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Thumbnail from "components/Thumbnail.jsx";

import clipPageStyle from "assets/jss/material-kit-react/views/clipPage.jsx";

const dashboardRoutes = [];

const API_DEFAULT = 'clips?_start=0&_end=11&_sort=id&_order=DESC&source=front';
const API_DEFAULT_SIMILAR_CLIPS = 'searchSimilar/';

class ClipPage extends React.Component {

  constructor(props) {
    super(props);
    const { params } = this.props.match;
    this.state = {
      idClip: params.id,
      similarClips: [],
    };
    this.fetchThumbnails(params.id);
    this.fetchSimilarClips(params.id);
  }

  componentWillReceiveProps(props){
    const { params } = props.match;
    this.setState({ idClip: params.id });
    this.setState({ similarClips: [] });
    this.fetchThumbnails(params.id);
    this.fetchSimilarClips(params.id);
  }

  fetchThumbnails(idClip){
    const api_base = process.env.REACT_APP_API_BASE;
    const url = api_base + API_DEFAULT + '&id_like=' + idClip;
    fetch(url)
      .then(response => response.json())
      .then(data => this.setState({ clip: data[0] }))
      .catch(function(error) {
        console.log('Erreur lors du fetch des thumbnails : ' + error.message);
      });
  }

  fetchSimilarClips(idClip){
    const api_base = process.env.REACT_APP_API_BASE;
    const url = api_base + API_DEFAULT_SIMILAR_CLIPS + idClip;
      fetch(url)
        .then(response => response.json())
        .then(data => this.setState({ similarClips: data }))
        .catch(function(error) {
          console.log('Erreur lors du fetch des clips similaires : ' + error.message);
        });
  }

  shortenTitle(text){
    return ClipUtils.shortenTitle(text)
  }

  computeUrl(clip){
    ClipUtils.computeUrl(clip.sentence, clip.id)
  }

  render() {
    const { classes, ...rest } = this.props;
    const { clip } = this.state;
    const { similarClips } = this.state;

    return (
      <div>
        <Helmet>
            <title>Répliculte - { clip ? this.shortenTitle(clip.sentence) : "Toutes les plus grandes répliques de film" }</title>
            <meta property="og:title" content={ clip ? 'Répliculte - '+this.shortenTitle(clip.sentence) : 'Toutes les plus grandes répliques de film' } />
            <meta property="og:url" content={ clip ? clip.url : '' } />
          { clip !== undefined  && <link rel="canonical" href={ 'https://www.repliculte.fr'+this.computeUrl(clip) } /> }
        </Helmet>

        <Header
          color="white"
          routes={dashboardRoutes}
          brand="Répliculte"
          fixed
          changeColorOnScroll={{
            height: 400,
            color: "white"
          }}
          {...rest}
        />

        <div className={classNames(classes.main, classes.mainRaised)} xs={12} sm={12} md={6}>
          <div className={classes.container}>
            <div className={classes.section}>
              {clip ? (
                <div>
                  <h1 className={classes.title}>{this.shortenTitle(clip.sentence)}</h1>
                    <GridContainer justify="center">
                      <GridItem xs={12} sm={12} md={8}>
                        <YouTube
                          id={clip.youtube_id}
                          appendSrc={"?start="+clip.start_time+"&end="+clip.end_time}/>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={4}>
                        <List>
                          <ListItem className={classNames(classes.block)}><span className={classNames(classes.itemTitle)}>Citation</span> :&nbsp;{clip.sentence}</ListItem>
                          {clip.episode &&
                            <div>
                              {clip.episode.name && <ListItem><span className={classNames(classes.itemTitle)}>Episode</span> :&nbsp;{clip.episode.name}</ListItem> }
                              {clip.episode.broadcasting_date > 0 && <ListItem><span className={classNames(classes.itemTitle)}>Date de diffusion</span> :&nbsp;{clip.episode.broadcasting_date}</ListItem> }
                            </div>
                          }
                          {clip.episode && clip.episode.serie &&
                            <div>
                              {clip.episode.serie.name && <ListItem><span className={classNames(classes.itemTitle)}>Série</span> :&nbsp;{clip.episode.serie.name}</ListItem> }
                              {clip.episode.season !== 0 && <ListItem><span className={classNames(classes.itemTitle)}>Saison</span> :&nbsp;{clip.episode.season}</ListItem> }
                              {clip.episode.episode_number !== 0 && <ListItem><span className={classNames(classes.itemTitle)}>Episode n°</span> :&nbsp;{clip.episode.episode_number}</ListItem> }
                            </div>
                          }
                          {clip.keywords.length > 0 &&
                            <ListItem><span className={classNames(classes.itemTitle)}>Mots-clés</span> :&nbsp;
                              {clip.keywords.map(keyword =>
                                <span className={classes.keyword}>#{keyword}&nbsp;</span>
                              )}
                            </ListItem>
                          }
                          {clip.persons.length > 0 &&
                            <ListItem className={classNames(classes.block)}><span className={classNames(classes.itemTitle)}>Personnage</span> :&nbsp;
                            {clip.persons.map(person =>
                              <span className={classes.person}>{person.name} ({person.actor})</span>
                            )}
                            </ListItem>
                          }
                        </List>
                      </GridItem>
                    </GridContainer>
                    <br />
                    <h2>Répliques cultes associées</h2>

                    <div className={classes.section}>
                      <GridContainer justify="center">
                        {
                          similarClips.length > 0 ? (
                            similarClips.map(clip =>
                              <GridItem xs={12} sm={6} md={4}>
                                <Thumbnail id={clip.id} youtube_id={clip.youtube_id} sentence={clip.sentence} start_time={clip.start_time} end_time={clip.end_time} />
                              </GridItem>
                            )
                          ) : (
                            <span className={classes.noVideoAvailable}>Aucune vidéo similaire trouvée.</span>
                          )
                        }
                      </GridContainer>
                    </div>


                </div>
              ) : (
                <p>Aucun clip correspondant.</p>
              )}
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

export default withStyles(clipPageStyle)(ClipPage);



// WEBPACK FOOTER //
// ./src/views/ClipPage/ClipPage.jsx